import capitalize from 'lodash/capitalize';
import { convertTimeString } from 'organisms/SearchStore/AU/SearchStoreUtilities/SearchStoreUtils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { convertTime } from 'common/utilities/utils';
export function getFormattedDay(item) {
  return (
    <span>
      {translateWithI18Next(capitalize(item?.day))}{' '}
      {item?.isSpecialHour && (
        <p className='special-day'>
          {item?.availableHours?.from === translateWithI18Next(TRANSLATE_MAPPING_KEY?.CLOSED_HOURS) &&
          item?.availableHours?.to === translateWithI18Next(TRANSLATE_MAPPING_KEY?.CLOSED_HOURS)
            ? translateWithI18Next(TRANSLATE_MAPPING_KEY?.SPECIAL_CLOSE)
            : translateWithI18Next(TRANSLATE_MAPPING_KEY?.SPECIAL_HOURS)}
        </p>
      )}
    </span>
  );
}
export const getDayOfWeek = item => {
  return (
    <>
      {translateWithI18Next(capitalize(item?.dayOfWeek))}
      {item?.isSpecialHour && (
        <p className='special-day'>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.SPECIAL_HOURS)}</p>
      )}
    </>
  );
};
export function getFormattedTime(item) {
  return item?.availableHours?.from !== translateWithI18Next(TRANSLATE_MAPPING_KEY?.CLOSED_HOURS) ||
    item?.availableHours?.to !== translateWithI18Next(TRANSLATE_MAPPING_KEY?.CLOSED_HOURS) ? (
    <p>
      {convertTimeString(item?.availableHours?.from)} - {convertTimeString(item?.availableHours?.to)}
    </p>
  ) : (
    <p>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.CLOSED)}</p>
  );
}
export const getAvailableHours = item => {
  if (
    item?.availableHours?.startTime === translateWithI18Next(TRANSLATE_MAPPING_KEY?.CLOSED_TIME) &&
    item?.availableHours?.endTime === translateWithI18Next(TRANSLATE_MAPPING_KEY?.CLOSED_TIME)
  ) {
    return translateWithI18Next(TRANSLATE_MAPPING_KEY?.CLOSED);
  } else {
    return `${convertTimeString(convertTime(item?.availableHours?.startTime))} - ${convertTimeString(
      convertTime(item?.availableHours?.endTime),
    )}`;
  }
};
